import React from "react";
import { Box } from "@mui/material";
import { GridFooterContainer, GridFooter } from '@mui/x-data-grid-pro';
import FieldWorkerSVG from "./FieldWorkerSVG";

export default function ReportFooter() {
    return (
        <GridFooterContainer>
            <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>Report generated using </span>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <FieldWorkerSVG />
                </span>
            </Box>
            <GridFooter />
        </GridFooterContainer>
    );
}
